<script>
  import solicitacaoImportacaoServico from '~modulos/solicitacao-importacao-projeto/servico';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import converterMoeda from '~js/converter-moeda';
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';

  export default {
    components: {  ModalMensagem, ModalLiberarCancelar, ModalArquivosSolicitacao },
    props: {
      solicitacoes: {
        required: true
      },
      projetos: {
        required: true,
      }
    }, 
    data() {
      return {
        modalMensagem: false,
        modalArquivos: false,
        modalLiberarCancelar: false,
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
      }
    },
    methods: {
      codigoImportacao(idSolicitacaoImportacao) {
        return 'MI-' + idSolicitacaoImportacao;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalLiberarCancelar = true;
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      liberar() {
        this.salvandoLiberacao = true;

        solicitacaoImportacaoServico
          .liberar(this.solicitacaoSelecionada.idSolicitacao)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.liberado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} liberada com sucesso.`);
            } else if (status.pendente) {
              toastr.warning(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} está pendente não é possível liberar.`);
            } else {
              toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
            $('body').removeClass('modal-open');
          })
          .then(this.lista);
      },
      cancelar() {
        this.salvandoLiberacao = true;

        solicitacaoImportacaoServico
          .cancelar(this.solicitacaoSelecionada.idSolicitacao)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.cancelado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} cancelada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
            $('body').removeClass('modal-open');
          })
          .then(this.lista);
      },
      labelCotacaoEstimada(cotacao) {
          return converterMoeda.paraCambio(cotacao);
      },
      lista(pagina = 1) {
        this.$emit('lista');
      },
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>

    <div class="group">
        <modal-mensagem :mostrar="modalMensagem"
                        :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCrypt : ''"
                        :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                        tipo="SolImportacao"
                        @fechado="modalMensagensFechado">
        </modal-mensagem>

        <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                                    tipo="importacao"
                                    :idProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.idProtocolo : ''"
                                    @fechado="modalArquivosFechado">
        </modal-arquivos-solicitacao>

        <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                                :salvando="salvandoLiberacao"
                                :liberando="configuracao.solCompraMsgConfirmacao ? false : true"
                                :mensagem="configuracao.solCompraMsgConfirmacao"
                                @fechado="modalLiberarCancelarFechado"
                                @liberar="liberar"
                                @cancelar="cancelar">
        </modal-liberar-cancelar>

        <div class="table-responsive">
            <table class="table table-bordered table-column-code table-column-action">
                <thead>
                    <tr>
                        <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
                        <th class="text-center">Número</th>
                        <th>Solicitante</th>
                        <th>Projeto</th>
                        <th>Data solicitação</th>
                        <th>Moeda</th>
                        <th>Valor total</th>
                        <th>Cotação estimada</th>
                        <th>Valor total estimado (R$)</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(solicitacao, index) in solicitacoes">
                        <td v-if="!configuracao.naoUtilizarMensageria">
                            <div v-if="solicitacao.quantidadeNaoLida > 0">
                                <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
                            </div>
                        </td>
                        <td class="text-center">{{ codigoImportacao(solicitacao.idSolicitacao) || '---' }}</td>
                        <td>{{ solicitacao.solicitante || '---' }}</td>
                        <td>{{ solicitacao.nomeProjeto || '---' }}</td>
                        <td>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</td>
                        <td>{{ solicitacao.nome || '---' }}</td>
                        <td>{{ solicitacao.valor | formatarNumero }}</td>
                        <td>{{ labelCotacaoEstimada(solicitacao.valor1) }}</td>
                        <td>{{ solicitacao.valor2 | formatarNumero }}</td>
                        <td>

                            <router-link class="btn btn-primary btn-xs"
                                         active-class=""
                                         v-tooltip="'Relatório'"
                                         :to="{ name: 'solicitacao-importacao-projeto.relatorio', params: { id: solicitacao.idSolicitacao , rota: 'liberar-solicitacoes' } }">
                                <i class="fa fa-file-text-o"></i>
                            </router-link>

                            <button v-if="!configuracao.usoEmailLiberarSolicitacao"
                                    class="btn btn-warning btn-xs"
                                    v-tooltip="'Liberar ou Cancelar solicitação'"
                                    @click="mostrarModalLiberarCancelar(solicitacao)">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button"
                                    class="btn btn-info btn-xs"
                                    v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                                    @click="mostrarModalArquivos(solicitacao)"
                                    v-if="configuracao.usarArquivosSolicitacaoImportacao">
                                <i class="fa fa-archive"></i>
                            </button>

                            <button type="button"
                                    class="btn btn-success btn-xs"
                                    v-tooltip="'Ler\Enviar mensagem'"
                                    @click="mostrarModalMensagem(solicitacao)"
                                    v-if="!configuracao.naoUtilizarMensageria">
                                <i class="fa fa-comment"></i>
                            </button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-solicitacoes/componentes/compartilhado/LiberarSolicitacaoImportacaoLista.vue